import ZkProgress from './src/progress';

/* istanbul ignore next */
ZkProgress.install = function(Vue) {
  Vue.component(ZkProgress.name, ZkProgress);
};

export default ZkProgress;



// WEBPACK FOOTER //
// ./src/packages/progress/index.js